// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"18ee51b1","876":"174cdb4c"}[chunkId] + ".chunk.css";
};